<div class="scoring-container">
  <div class="factor-modal-title">
    <h2>{{ selectedFactor ? 'Editar Factor' : 'Añadir Factor' }}</h2>
  </div>
  <div class="body">
    <div class="field">
      <label for="name">Nombre*</label>
      <input
        id="name"
        type="text"
        [(ngModel)]="name"
        (input)="validateSpecialCharacters($event)"
        placeholder="Nombre del factor"
        maxlength="50"
        required
      />
    </div>
    <div class="field">
      <label for="weight">Peso*</label>
      <input
        id="weight"
        type="number"
        (input)="validateWeigth($event)"
        (keydown)="validateOnlyNumbers($event)"
        [(ngModel)]="weight"
        placeholder="Peso del factor"
        maxlength="2"
        required
      />
    </div>
    <div class="field">
      <label for="points">Puntos*</label>
      <input
        id="points"
        type="number"
        (input)="validatePoints($event)"
        (keydown)="validateOnlyNumbers($event)"
        [(ngModel)]="points"
        placeholder="Puntos"
        maxlength="4"
        required
      />
    </div>
  </div>
  <div class="buttons-footer">
    <button id="cancelButton" class="ind-button-lite" (click)="cancelClick()">
      <span class="text-buttons">Cancelar</span>
    </button>
    <button id="saveButton" class="ind-button" (click)="onSubmit()">
      <span class="text-buttons">Guardar</span>
    </button>
  </div>
</div>
